import { Breadcrumbs, CircularProgress, Grid, Typography } from '@mui/material';
import PageTitle from '../../../common/PageTitle';
import HomeIcon from '@mui/icons-material/Home';
import LinkNavegacao from '../../../common/Link';
import CardOption from '../../../common/CardOption';
import { ProductDocumentsIcon } from '../../../common/Icons';
import React, { useEffect, useState } from "react";
import { verifyUserAbilities } from "../../../config/functions";

function Organization() {
    const [abilities, setAbilities] = useState({});
    const [loading, setLoading] = useState(true);

    const permissoesBlocos = [
        {
            titulo: "Administre a organização das empresa.",
            permissoes: [
                { rota: "departamentos", title: "Departamentos", description: "Gerencie os departamentos da sua empresa", url: "departamentos" },
                { rota: "areas", title: "Áreas", description: "Gerencie as áreas da sua empresa", url: "areas" },
                { rota: "setores", title: "Setores", description: "Gerencie os setores da sua empresa", url: "setores" },
                { rota: "funcoes", title: "Funções", description: "Gerencie as funções dos colaboradores da sua empresa", url: "funcoes" },
                { rota: "centroCustos", title: "Centros de Custo", description: "Gerencie os centros de custo da sua empresa", url: "centros_de_custo" },
                { rota: "regimeTrabalho", title: "Regimes de Trabalho", description: "Gerencie os regimes de trabalho que podem ser atribuídos a um colaborador", url: "regimes_de_trabalho" },
                { rota: "tipoDocumento", title: "Tipos de Documento", description: "Gerencie os tipos de documentos que podem ser atribuídos a um colaborador", url: "tipos_de_documento" },
            ]
        },
        {
            titulo: "Administre os pontos de entrega e estoque das empresas.",
            permissoes: [
                { rota: "pontoEntrega", title: "Pontos de Entrega", description: "Gerencie os pontos de entrega das empresas", url: "pontos_de_entrega" },
                { rota: "estoque", title: "Estoque", description: "Gerencie os estoque das empresas", url: "estoque" },
            ]
        }
    ];

    useEffect(() => {
        const carregarPermissoes = async () => {
            const todasPermissoes = permissoesBlocos.flatMap(bloco => bloco.permissoes);
            const resultados = {};

            await Promise.all(todasPermissoes.map(async (item) => {
                resultados[item.rota] = await verifyUserAbilities({ rota: item.rota });
            }));

            setAbilities(resultados);
            setLoading(false);
        };

        carregarPermissoes();
    }, []);

    if (loading) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ height: "100vh" }}>
                <CircularProgress />
            </Grid>
        );
    }

    const renderBloco = (titulo, permissoes) => (
        <>
            <Grid item xs={12}>
                <Typography variant='h6' mt={1}>
                    {titulo}
                </Typography>
            </Grid>
            {permissoes.map(item => {
                const temPermissao = abilities[item.rota]?.data.success;
                return (
                    <Grid
                        key={item.rota}
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={4}
                        xl={3}
                        sx={{
                            opacity: temPermissao ? 1 : 0.5,
                            pointerEvents: temPermissao ? 'auto' : 'none',
                        }}
                    >
                        <CardOption
                            title={item.title}
                            description={item.description}
                            url={item.url}
                            hasPermisson={temPermissao}
                            sx={{
                                backgroundColor: temPermissao ? 'transparent' : 'gray',
                                color: temPermissao ? 'black' : 'gray',
                            }}
                        />
                    </Grid>
                )
            })}
        </>
    );

    return (
        <Grid container direction="row" justifyContent="flex-start" alignItems="stretch" spacing={2}>
            <Grid item xs={12}>
                <Breadcrumbs>
                    <LinkNavegacao to='/'><HomeIcon fontSize='small' /></LinkNavegacao >
                    <Typography variant='span'>Gerenciamento</Typography>
                    <Typography variant='span'>Organização</Typography>
                </Breadcrumbs>
                <PageTitle icon={<ProductDocumentsIcon fontSize='large' />} title='Organização' />
            </Grid>

            {permissoesBlocos.map((bloco, idx) => (
                <React.Fragment key={idx}>
                    {renderBloco(bloco.titulo, bloco.permissoes)}
                </React.Fragment>
            ))}
        </Grid>
    );
}

export default Organization;